import "./MainGallery.css";

import img3 from '../images/gall3.webp';
import img4 from '../images/gall4.webp';

export default function MainGallery() {
  return (
    <section className="container-fluid ayg-section py-5">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-4">
          <p className="ayg-subtitle">OUR GALLERY</p>
          <h2 className="ayg-title head-font">
            See the Essence of Ayurveda Come Alive
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="row g-3">

          <div className="col-lg-3 col-md-6">
            <div className="ayg-img-box">
              <img
                 src={img3}
               
                alt="Ayurveda Therapy 1"
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="ayg-img-box">
              <img
                src="https://images.unsplash.com/photo-1515377905703-c4788e51af15"
                alt="Ayurveda Therapy 2"
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="ayg-img-box">
              <img
                 src="https://images.unsplash.com/photo-1600334129128-685c5582fd35"
                alt="Ayurveda Products"
              />
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="ayg-img-box">
              <img
                src={img4}
                alt="Ayurveda Relaxation"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
